module.exports = __webpack_public_path__ + "img/Movile-down.dcb446d7.jpg";